import {
  kashmirFilesMovieIds,
  rrrMovieIds,
  karthikeyaMovieIds,
  rangbaazWebSeriesIds,
  karthikeyaGlobalUrlMapping,
  kashmirFilesGlobalUrlMapping,
  rangbaazGlobalUrlMapping,
  rrrGlobalUrlMapping,
  kashmirFilesUrlMapping,
  karthikeyaUrlMapping,
  rangbaazUrlMapping,
  rrrUrlMapping,
  X_DEFAULT_HREF_LANG
} from 'src/utils/constants/CanonicalURLConstants';

import { getUrlSplit } from './SEOURLUtils';
import { DynamicObject } from '../../utils/commonTypes';
import {
  WANTED_AND_WRITER_PADMABUSHAN,
  WANTED_CONTENT_ID,
  WRITER_PADMABUSHAN_CONTENT_ID
} from '../../utils/constants/SEOMetaConstants';
import { CountryCode } from '../../utils/constants/stringConstants';
import {
  BASE_URL,
  INTERNATIONAL_LANGUAGES_LIST,
  INDIA_LANGUAGES_LIST
} from '../../utils/constants/utilConstants';
import {
  getEpisodeIndex,
  getURL,
  GLOBAL_LADIES_AND_GENTLEMEN_EPISODES,
  INDIA_LADIES_AND_GENTLEMEN_EPISODES,
  LADIES_AND_GENTLEMEN_COUNTRIES
} from '../../utils/OGTags';

export const getXDefaultLangURL = (
  id: string,
  isGlobalLanguages: boolean,
  isIndianLanguages: boolean,
  routerPath: string,
  country: string,
  episodeIndex = -1
) => {
  if (kashmirFilesMovieIds.includes(id)) {
    const hrefArray = [];
    if (isGlobalLanguages)
      hrefArray.push(X_DEFAULT_HREF_LANG.GLOBAL.KASHMIR_FILES);
    if (isIndianLanguages)
      hrefArray.push(X_DEFAULT_HREF_LANG.INDIA.KASHMIR_FILES);
    return hrefArray;
  } else if (rrrMovieIds.includes(id)) {
    return [X_DEFAULT_HREF_LANG.GLOBAL.RRR];
  } else if (karthikeyaMovieIds.includes(id)) {
    return [X_DEFAULT_HREF_LANG.GLOBAL.KARTHIKEYA];
  } else if (rangbaazWebSeriesIds.includes(id)) {
    return [X_DEFAULT_HREF_LANG.GLOBAL.RANGBAAZ];
  } else if (
    episodeIndex < 0 &&
    !kashmirFilesMovieIds.includes(id) &&
    !rrrMovieIds.includes(id) &&
    !karthikeyaMovieIds.includes(id) &&
    !rangbaazWebSeriesIds.includes(id) &&
    (isGlobalLanguages || isIndianLanguages)
  ) {
    return [
      getURL(
        country === CountryCode.IN ? CountryCode.IN : CountryCode.GLOBAL,
        'en',
        routerPath
      )
    ];
  }
  return [];
};
export const getInternationalLangObjects = (
  id: string,
  ogUrl: string,
  countryCode: string,
  routerPath: string,
  isGlobalLanguages: boolean,
  hasApiData?: boolean
) => {
  const isIndia = countryCode === CountryCode.IN;
  const episodeIndex = id && routerPath ? getEpisodeIndex(id, countryCode) : -1;
  const isWantedGlobal = ogUrl?.includes(WANTED_CONTENT_ID) && isIndia;
  const isWriterPadhmaBushan =
    ogUrl?.includes(WRITER_PADMABUSHAN_CONTENT_ID) && isIndia;
  const urlSplit = id && routerPath ? getUrlSplit(routerPath) : undefined;

  if (kashmirFilesMovieIds.includes(id)) {
    return Object.keys(kashmirFilesGlobalUrlMapping).map((element) => {
      return {
        hrefLang:
          kashmirFilesGlobalUrlMapping[
            element as keyof typeof kashmirFilesGlobalUrlMapping
          ][1],
        href: kashmirFilesGlobalUrlMapping[
          element as keyof typeof kashmirFilesGlobalUrlMapping
        ][0]
      };
    });
  } else if (hasApiData && rrrMovieIds.includes(id)) {
    return Object.keys(rrrGlobalUrlMapping).map((element) => {
      return {
        hrefLang:
          rrrGlobalUrlMapping[element as keyof typeof rrrGlobalUrlMapping][1],
        href: rrrGlobalUrlMapping[
          element as keyof typeof rrrGlobalUrlMapping
        ][0]
      };
    });
  } else if (hasApiData && karthikeyaMovieIds.includes(id))
    return Object.keys(karthikeyaGlobalUrlMapping).map((element) => {
      return {
        hrefLang:
          karthikeyaGlobalUrlMapping[
            element as keyof typeof karthikeyaGlobalUrlMapping
          ][1],
        href: karthikeyaGlobalUrlMapping[
          element as keyof typeof karthikeyaGlobalUrlMapping
        ][0]
      };
    });
  else if (isGlobalLanguages && rangbaazWebSeriesIds.includes(id))
    return Object.keys(rangbaazGlobalUrlMapping).map((element) => {
      return {
        hrefLang:
          rangbaazGlobalUrlMapping[
            element as keyof typeof rangbaazGlobalUrlMapping
          ][1],
        href: rangbaazGlobalUrlMapping[
          element as keyof typeof rangbaazGlobalUrlMapping
        ][0]
      };
    });
  else if (isWantedGlobal || isWriterPadhmaBushan) {
    return WANTED_AND_WRITER_PADMABUSHAN.map((hrefLang) => {
      return {
        hrefLang: hrefLang,
        href: ogUrl
      };
    });
  } else if (episodeIndex >= 0) {
    return LADIES_AND_GENTLEMEN_COUNTRIES.map((hreflang) => {
      return {
        hrefLang: hreflang,
        href: `${BASE_URL}/global${urlSplit}/${GLOBAL_LADIES_AND_GENTLEMEN_EPISODES[episodeIndex]}`
      };
    });
  } else if (
    episodeIndex < 0 &&
    !isWantedGlobal &&
    !isWriterPadhmaBushan &&
    ogUrl &&
    isGlobalLanguages
  )
    return INTERNATIONAL_LANGUAGES_LIST.map((lang) => {
      //no id used because last fallback only
      return {
        hrefLang: lang,
        href: `${getURL(CountryCode.GB, lang, routerPath)}`
      };
    });
  else return [];
};

export const getIndianLangObjects = (
  id: string,
  countryCode: string,
  routerPath: string,
  ogUrl: string
) => {
  const isIndia = countryCode === CountryCode.IN;
  const episodeIndex = id && routerPath ? getEpisodeIndex(id, countryCode) : -1;
  const isWantedGlobal = ogUrl?.includes(WANTED_CONTENT_ID) && isIndia;
  const isWriterPadhmaBushan =
    ogUrl?.includes(WRITER_PADMABUSHAN_CONTENT_ID) && isIndia;
  const urlSplit = id && routerPath ? getUrlSplit(routerPath) : undefined;
  if (kashmirFilesMovieIds.includes(id))
    return Object.keys(kashmirFilesUrlMapping).map((element) => {
      return {
        hrefLang:
          kashmirFilesUrlMapping[
            element as keyof typeof kashmirFilesUrlMapping
          ][1],
        href: kashmirFilesUrlMapping[
          element as keyof typeof kashmirFilesUrlMapping
        ][0]
      };
    });
  else if (rrrMovieIds.includes(id))
    return Object.keys(rrrUrlMapping).map((element) => {
      // causing issues with international languages
      return {
        hrefLang: rrrUrlMapping[element as keyof typeof rrrUrlMapping][1],
        href: rrrUrlMapping[element as keyof typeof rrrUrlMapping][0]
      };
    });
  else if (karthikeyaMovieIds.includes(id))
    return Object.keys(karthikeyaUrlMapping).map((element) => {
      return {
        hrefLang:
          karthikeyaUrlMapping[element as keyof typeof karthikeyaUrlMapping][1],
        href: karthikeyaUrlMapping[
          element as keyof typeof karthikeyaUrlMapping
        ][0]
      };
    });
  else if (rangbaazWebSeriesIds.includes(id))
    return Object.keys(rangbaazUrlMapping).map((element) => {
      return {
        hrefLang:
          rangbaazUrlMapping[element as keyof typeof rangbaazUrlMapping][1],
        href: rangbaazUrlMapping[element as keyof typeof rangbaazUrlMapping][0]
      };
    });
  else if (episodeIndex >= 0) {
    return [
      {
        hrefLang: `en-in`,
        href: `${BASE_URL}${urlSplit}/${INDIA_LADIES_AND_GENTLEMEN_EPISODES[episodeIndex]}`
      }
    ];
  } else if (!isWantedGlobal && !isWriterPadhmaBushan)
    return INDIA_LANGUAGES_LIST.map((lang) => {
      return {
        hrefLang: `${lang}-in`,
        href: `${getURL(CountryCode.IN, lang, routerPath)}`
      };
    });
  else return [];
};
